"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @param {number} debtId A reference to a single debt
 * @class DebtDemands
 * @classdesc Handles a debt's demand letters
 */
var DebtDemands = /** @class */ (function () {
    function DebtDemands(recover, debtId) {
        var _this = this;
        this.recover = recover;
        this.debtId = debtId;
        /**
         *
         *
         * @memberof DebtDemands
         * @returns {SuccessfulIndexDemandsResponse} Returns a message and information on all demand letters generated
         * @description Returns an index of all demand information for a single debt
         */
        this.index = function () {
            return _this.recover.request("/debts/" + _this.debtId + "/demands", "GET", null, null);
        };
        //Will not work as does not return JSON
        /**
         *
         *
         * @memberof DebtDemands
         * @returns {Blob} Returns a PDF
         * @description Returns an upcoming demand in PDF format.  This doesnt work through NPM module, use a standard fetch request /debts/${this.debtId}/upcoming_demand_pdf
         */
        this.getUpcoming = function () {
            return _this.recover.request("/debts/" + _this.debtId + "/upcoming_demand_pdf", "GET", null, null);
        };
        /**
         *
         *
         * @memberof DebtDemands
         * @returns {SuccessfulPostDemandsResponse} Returns a message and an object with the newly generated demands info
         * @property {number} stage An id referencing stage 1 or 2
         * @description Confirms a demand
         */
        this.post = function (stage) {
            return _this.recover.request("/debts/" + _this.debtId + "/demand/" + stage, "POST", {}, null);
        };
    }
    return DebtDemands;
}());
exports.default = DebtDemands;
